'use client';

import {footerFallbackRU} from '@strapi/endpoints/Footer/footer.fallback';
import {headerFallbackRu} from '@strapi/endpoints/Header/header.fallback';
import {Footer} from '@ui-kit/src/Footer';
import {useReportErrorFromBoundary} from '@utils/tracer/useReportErrorFromBoundary';

import Error500Svg from '@web-catalog/assets/icons/500.svg';

import {Layout} from '@web-catalog/components/Layout';
import {StrapiHeader} from '@web-catalog/components/StrapiHeader';

import {FooterStrapi, StrapiHeaderRequest} from '@strapi/types';

import {Icon} from '@web-catalog/ui-kit/Icon';
import {Text} from '@web-catalog/ui-kit/Text';

import {parseStrapiFooter, parseStrapiHeader} from '@web-catalog/utils';

import styles from './error.module.scss';

function Error({
  error,
  hideSearchButton,
}: {
  error: Error & {digest?: string};
  hideSearchButton?: boolean;
}) {
  useReportErrorFromBoundary(error, error.digest);

  return (
    <>
      <StrapiHeader
        {...parseStrapiHeader(
          headerFallbackRu as unknown as StrapiHeaderRequest,
        )}
        hideSearchButton={hideSearchButton}
      />

      <Layout isFullwidth>
        <div className={styles.root}>
          <div className={styles.top}>
            <div className={styles.container}>
              <Icon svg={Error500Svg} className={styles.heroImage} />

              <Text
                typography="subheader-2"
                color="black-100"
                className={styles.title}
              >
                Что-то пошло не так
              </Text>

              <Text
                typography="content-s"
                color="neutral-300"
                className={styles.subtitle}
              >
                Попробуйте обновить страницу или зайти позже
              </Text>

              <button
                onClick={() => window.location.reload()}
                data-testid="errorPageRefreshButton"
                className={styles.resetButton}
              >
                Обновить страницу
              </button>
            </div>
          </div>
        </div>
      </Layout>

      <Footer
        {...parseStrapiFooter(footerFallbackRU as unknown as FooterStrapi)}
      />
    </>
  );
}

export default Error;
